export class ProductFormBundleSet extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.parent = this.closest('[data-bundle-items-parent]')
    this.bundleVariantIdEls = this.parent.querySelectorAll(
      '[data-current-variant-id]',
    )
  }

  setupListeners () {
    super.setupListeners()

    this.onSubmitHandler = this.onSubmitHandler.bind(this)
    this.listeners.add(this.form, 'submit', this.onSubmitHandler)
  }

  allSelectedAvailable () {
    const parent = this.element.closest(this.parent)

    const variants = [
      ...parent.querySelectorAll('[data-current-variant-available]'),
    ]

    return {
      allSelected: variants.every(el => el.dataset.selectionMade === 'true'),
      available: variants.every(
        el =>
          el.dataset.currentVariantAvailable === 'true' &&
          el.dataset.selectionMade === 'true',
      ),
      inStock: variants.some(
        el =>
          el.dataset.currentVariantAvailable === 'true' ||
          el.dataset.selectionMade === 'true',
      ),
      outOfStock: variants.some(
        el =>
          el.dataset.currentVariantAvailable === 'false' ||
          el.dataset.selectionMade !== 'true',
      ),
    }
  }

  checkValidity () {
    super.checkValidity()

    if (!this.form) {
      this.throwError(`needs to be wrapped around a product's <form> element`)
    }
  }

  async onSubmitHandler (e) {
    e.preventDefault()

    await this.addToCart()
  }

  async addToCart () {
    for (const variantId of this.bundleVariantIds) {
      await window.BAO.Cart.addItem({
        id: variantId,
        quantity: 1,
      })
    }
  }

  /**
   * @returns {Boolean}
   */
  get someCurrentVariantsAvailable () {
    return [...this.bundleVariantIdEls].some(
      el => el.dataset.currentVariantAvailable === 'true',
    )
  }

  /**
   * @returns {Boolean}
   */
  get allCurrentVariantsAvailable () {
    return [...this.bundleVariantIdEls].every(
      el => el.dataset.currentVariantAvailable === 'true',
    )
  }

  /**
   * @returns {HTMLFormElement|null}
   */
  get form () {
    return this.querySelector('form')
  }

  /**
   * @returns {Array|null}
   */
  get bundleVariantIds () {
    return [...this.bundleVariantIdEls]
      .reverse()
      .map(el => el.dataset.currentVariantId)
  }
}

customElements.define('product-form-bundle-set', ProductFormBundleSet)
